var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "col-xs-12 col-md-4 col-lg-3 col-xl-2 system-messages" },
    [
      _c("header", [_vm._v("System Messages")]),
      _vm._v(" "),
      _c(
        "section",
        [
          _vm.isLoading && this.isFirstRun("transactions_status")
            ? [_c("loader")]
            : this.hasData("transactions_status")
            ? [
                this.data.hasOwnProperty("call_status") &&
                this.data.call_status === "FAILED"
                  ? _c("div", { staticClass: "alert alert-info" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(this.data.message) +
                          "\n            "
                      )
                    ])
                  : [
                      _c(
                        "ul",
                        { staticClass: "system-messages" },
                        _vm._l(this.data, function(entries, date) {
                          return _c("li", { staticClass: "day" }, [
                            _c("span", { staticClass: "timestamp" }, [
                              _vm._v(_vm._s(date))
                            ]),
                            _vm._v(" "),
                            _c(
                              "ul",
                              _vm._l(entries, function(entry, index) {
                                return _c("li", [
                                  _c(
                                    "span",
                                    { staticClass: "timestamp-hour" },
                                    [_vm._v(_vm._s(entry.log_time))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "message-bg" },
                                    [
                                      entry.action_metadata &&
                                      entry.action_metadata.action_name &&
                                      entry.action_metadata.action_name !== ""
                                        ? [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  entry.action_metadata
                                                    .action_name
                                                )
                                              )
                                            ]),
                                            _c("br"),
                                            _vm._v(" "),
                                            entry.action_metadata.entity_name &&
                                            entry.action_metadata
                                              .entity_name !== ""
                                              ? [
                                                  _c("span", [
                                                    _vm._v(
                                                      "Entity: " +
                                                        _vm._s(
                                                          entry.action_metadata
                                                            .entity_name
                                                        )
                                                    )
                                                  ]),
                                                  _c("br")
                                                ]
                                              : _vm._e(),
                                            _vm._v(" "),
                                            entry.action_metadata.domain_name &&
                                            entry.action_metadata
                                              .domain_name !== ""
                                              ? [
                                                  _c("span", [
                                                    _vm._v(
                                                      "Domain: " +
                                                        _vm._s(
                                                          entry.action_metadata
                                                            .domain_name
                                                        )
                                                    )
                                                  ]),
                                                  _c("br")
                                                ]
                                              : _vm._e()
                                          ]
                                        : [
                                            _c(
                                              "span",
                                              { staticClass: "target" },
                                              [_vm._v("Type: ")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "message" },
                                              [
                                                _vm._v(
                                                  _vm._s(entry.action_type)
                                                )
                                              ]
                                            ),
                                            _c("br")
                                          ],
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          "Status:\n                                        "
                                        ),
                                        _c(
                                          "span",
                                          { class: entry.status_class },
                                          [
                                            entry.status.toLowerCase() ==
                                            "in progress"
                                              ? [
                                                  _c("fa", {
                                                    attrs: {
                                                      icon: "spinner",
                                                      spin: ""
                                                    }
                                                  })
                                                ]
                                              : _vm._e(),
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(entry.status) +
                                                "\n                                        "
                                            )
                                          ],
                                          2
                                        )
                                      ]),
                                      _vm._v(" "),
                                      "action_details" in entry &&
                                      "has_details" in entry.action_details &&
                                      entry.action_details.has_details === 1
                                        ? [
                                            _c(
                                              "button",
                                              {
                                                staticClass: "c-btn c-btn-info",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.show_details(
                                                      date,
                                                      index
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                            Details\n                                        "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            entry.progress >= 0 &&
                                            entry.progress < 100
                                              ? [
                                                  _vm._v(
                                                    "\n                                          Progress: " +
                                                      _vm._s(entry.progress) +
                                                      "%\n                                        "
                                                  )
                                                ]
                                              : _vm._e()
                                          ]
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c("span", [
                                        _c("em", [
                                          _vm._v(
                                            "by: " + _vm._s(entry.username)
                                          )
                                        ])
                                      ])
                                    ],
                                    2
                                  )
                                ])
                              }),
                              0
                            )
                          ])
                        }),
                        0
                      )
                    ]
              ]
            : [
                _c("div", { staticClass: "alert alert-info" }, [
                  _vm._v("No recent operations")
                ])
              ]
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "transaction-details-ccs-modal",
        {
          attrs: {
            "min-width": 200,
            "min-height": 200,
            "pivot-y": 0.5,
            adaptive: true,
            scrollable: true,
            reset: true,
            width: "60%",
            height: "auto"
          }
        },
        [
          _c(
            "template",
            { slot: "content" },
            [
              _vm.transaction_detail_index > -1
                ? _c("TransactionDetails", {
                    attrs: {
                      transaction_data:
                        _vm.data[_vm.transaction_detail_date][
                          _vm.transaction_detail_index
                        ]
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }